export default {"src":"/_next/static/media/hamburger.c2276bb4.svg","height":20,"width":32};